import AppHost from "./host/AppHost";

export default AppHost;